/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_link_minecraft_invalid_token = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid or expired link ticket. Please run /beaconauth link again in-game.`)
};

const zh_hans1_link_minecraft_invalid_token = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绑定凭证无效或已过期，请在游戏内重新执行 /beaconauth link 获取新链接。`)
};

const zh_hant1_link_minecraft_invalid_token = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`綁定憑證無效或已過期，請在遊戲內重新執行 /beaconauth link 獲取新連結。`)
};

const fr_link_minecraft_invalid_token = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket de liaison invalide ou expiré. Veuillez réexécuter /beaconauth link en jeu.`)
};

const de_link_minecraft_invalid_token = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiges oder abgelaufenes Ticket. Bitte führen Sie /beaconauth link im Spiel erneut aus.`)
};

const ja_link_minecraft_invalid_token = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携チケットが無効または期限切れです。ゲーム内で再度 /beaconauth link を実行してください。`)
};

const ko_link_minecraft_invalid_token = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연동 티켓이 유효하지 않거나 만료되었습니다. 게임 내에서 /beaconauth link를 다시 실행해주세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const link_minecraft_invalid_token = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.link_minecraft_invalid_token(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("link_minecraft_invalid_token", locale)
	if (locale === "en") return en_link_minecraft_invalid_token(inputs)
	if (locale === "zh-Hans") return zh_hans1_link_minecraft_invalid_token(inputs)
	if (locale === "zh-Hant") return zh_hant1_link_minecraft_invalid_token(inputs)
	if (locale === "fr") return fr_link_minecraft_invalid_token(inputs)
	if (locale === "de") return de_link_minecraft_invalid_token(inputs)
	if (locale === "ja") return ja_link_minecraft_invalid_token(inputs)
	return ko_link_minecraft_invalid_token(inputs)
};